import { CLASSNAME_HIDDEN } from '@vfde-brix/core';

/**
 * trigger is an element which is needed from gigakombi-xsell container
 * clickEvent pseudo Event to reset the gigakombi-xsell container
 *
 * a button-click on the gigakombi-xsell page resets the overlay (till the page is not longer Botox)
 * we simulate the same behaviour on our sales overlay open
 */
export const gigaKombiXSellHelper = (overlayTargetId) => {
    const clickEvent = new Event('click');
    const trigger = createHTMLElement('continue-with-offer');
    const contentTarget = createHTMLElement(overlayTargetId);
    contentTarget.classList.add(CLASSNAME_HIDDEN);

    return {
        contentTarget,
        clickEvent,
        trigger,
    };
};

const createHTMLElement = id => {
    const element = document.createElement('div');
    element.id = id;
    document.body.appendChild(element);

    return element;
};
